module.exports = __webpack_public_path__ + "static/img/9.96af588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/9.jpg
// module id = cEc/
// module chunks = 1